import {
   FormControl,
   Grid,
   Icon,
   IconButton,
   InputAdornment,
   InputLabel,
   OutlinedInput,
   Typography,
   Popover,
   FormHelperText
} from '@material-ui/core'
import React, { useState, useEffect, useRef, useCallback } from 'react'
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state'
import { makeStyles } from '@material-ui/core/styles'
import { ListItem, ListItemText } from '@material-ui/core'
import { VariableSizeList as List } from 'react-window'
import PropTypes from 'prop-types'
import _ from 'lodash'
import iconsMaterialAPI from '../../services/IconsMaterialApi'
import DeviceHubNew from 'images/icons/subdomain/DeviceHubNew'

const useStyles = makeStyles(theme => ({
   root: {
      flexGrow: 1
   },
   paper: {
      padding: theme.spacing(2),
      margin: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary
   },
   iconsContainer: {
      width: 350,
      padding: '0 7px'
   },
   formControl: {
      width: '100%',
      textAlign: 'initial',
      fontSize: 14,
      marginTop: 10,
      marginBottom: 10
   },
   messageFilter: {
      padding: '1rem 0'
   }
}))

const rowItemStyles = makeStyles({
   rowItemIcon: {
      marginRight: '0.4rem'
   }
})

export const IconsSelector = ({
   handleIconSelected,
   error,
   styleHelperText,
   messageError,
   variant,
   size,
   value
}) => {
   const sizeMap = useRef({})
   const refInput = useRef()
   const timerChangeFilter = useRef()
   const originalIconList = useRef()
   const refPopupState = useRef()
   const debounceTime = 1000
   const classes = useStyles()
   const [iconsList, setIconsList] = useState([])
   const [isLoading, setLoading] = useState(false)

   useEffect(() => {
      getIcons()
   }, [])

   const getItemSize = useCallback(index => sizeMap.current[index] || 50, [])

   const getIcons = () => {
      const icons = iconsMaterialAPI.getAllIcons().icons
      icons.push({ name: 'device_hub_new', tags: ['custom'] })
      setIconsList(icons)
      originalIconList.current = icons
   }

   const filterIcon =
      (word = '') =>
      () => {
         if (Array.isArray(originalIconList.current)) {
            if (word) {
               const inconsFiltered = originalIconList.current.filter(
                  icon => icon.tags.includes(word) || icon.name.includes(word)
               )
               setIconsList(inconsFiltered)
            } else {
               setIconsList(originalIconList.current)
            }
         }
         setLoading(false)
      }

   const clearSearch = () => {
      if (typeof timerChangeFilter.current === 'function') {
         timerChangeFilter.current.cancel()
      }
   }

   const handleInputChange = e => {
      e.persist()
      const strSearch = `${e.target.value}`.toLowerCase().trim()
      if (strSearch.length) {
         setLoading(true)
      }
      clearSearch()
      const dbcFn = _.debounce(
         filterIcon(strSearch),
         strSearch.length ? debounceTime : 0
      )
      timerChangeFilter.current = dbcFn
      timerChangeFilter.current()
   }

   const selectIcon = icon => {
      handleIconSelected(icon.name)
      if (refPopupState.current) {
         refPopupState.current._setStateIfMounted(prevState => {
            return { ...prevState, isOpen: false }
         })
      }
   }

   const Row = prop => {
      const { index, style, data } = prop
      const icon = data[index]
      const stylesRowItem = rowItemStyles({ index })

      // Verificar si es el nuevo icono personalizado
      if (icon.name === 'device_hub_new') {
         return (
            <ListItem
               key={index}
               button
               style={style}
               onClick={() => selectIcon(icon)}
            >
               <DeviceHubNew />
               <ListItemText>
                  <span style={{ paddingLeft: '.6rem' }}>{icon.name}</span>
               </ListItemText>
            </ListItem>
         )
      }
      return (
         <ListItem
            key={index}
            button
            style={style}
            onClick={() => selectIcon(icon)}
         >
            <Icon className={stylesRowItem.rowItemIcon}>{icon.name} </Icon>
            <ListItemText>
               <span>{icon.name}</span>
            </ListItemText>
         </ListItem>
      )
   }

   const getIsNotFound = useCallback(() => {
      return !isLoading && !iconsList.length
   }, [isLoading, iconsList])

   const canShowListIcons = useCallback(() => {
      return !isLoading && !!iconsList.length
   }, [isLoading, iconsList])

   return (
      <div className={classes.root}>
         <Grid container spacing={2}>
            <Grid container className={classes.iconsContainer}>
               <PopupState
                  variant="popover"
                  popupId="icon-popup"
                  ref={refPopupState}
               >
                  {popupState => (
                     <div ref={refInput} style={{ width: '100%' }}>
                        <FormControl
                           className={classes.formControl}
                           variant={variant}
                           size={size}
                           error={error}
                           {...bindTrigger(popupState)}
                        >
                           <InputLabel id="icon-selector">
                              Icono Portal*{' '}
                           </InputLabel>
                           <OutlinedInput
                              error={error}
                              inputProps={{
                                 name: 'status',
                                 id: 'icon-selector'
                              }}
                              id="icon-selector"
                              anchorOrigin={{
                                 vertical: 'bottom',
                                 horizontal: 'center'
                              }}
                              transformOrigin={{
                                 vertical: 'top',
                                 horizontal: 'center'
                              }}
                              readOnly
                              endAdornment={
                                 <InputAdornment position="end">
                                    {value === 'device_hub_new' ? (
                                       <IconButton aria-label="toggle password visibility">
                                          <DeviceHubNew />
                                       </IconButton>
                                    ) : (
                                       <IconButton aria-label="toggle password visibility">
                                          {value && <Icon>{value}</Icon>}
                                       </IconButton>
                                    )}
                                 </InputAdornment>
                              }
                              labelWidth={40}
                              value={value || ''}
                           />
                           <FormHelperText className={styleHelperText}>
                              {error && messageError}
                           </FormHelperText>
                        </FormControl>
                        <Popover
                           {...bindPopover(popupState)}
                           onExit={clearSearch}
                           style={{ height: 250 }}
                           anchorOrigin={{
                              vertical: 'top',
                              horizontal: 'center'
                           }}
                           transformOrigin={{
                              vertical: 'top',
                              horizontal: 'center'
                           }}
                        >
                           <Grid
                              container
                              className={classes.iconsContainer}
                              direction="row"
                              justify="center"
                              alignItems="center"
                           >
                              <Grid
                                 xs={24}
                                 style={{ width: '100%', marginTop: 20 }}
                              >
                                 <FormControl
                                    className={classes.formControl}
                                    variant="outlined"
                                    size="small"
                                 >
                                    <InputLabel>Filtrar</InputLabel>
                                    <OutlinedInput
                                       label="Descripción"
                                       name="description"
                                       size="small"
                                       onChange={handleInputChange}
                                    />
                                 </FormControl>
                              </Grid>
                              {isLoading && (
                                 <Typography
                                    variant="h6"
                                    align="center"
                                    className={classes.messageFilter}
                                 >
                                    Buscando...
                                 </Typography>
                              )}
                              {canShowListIcons() && (
                                 <List
                                    height={150}
                                    itemData={iconsList}
                                    itemCount={iconsList.length}
                                    itemSize={getItemSize}
                                    width={300}
                                 >
                                    {Row}
                                 </List>
                              )}
                              {getIsNotFound() && (
                                 <Typography
                                    variant="h6"
                                    align="center"
                                    className={classes.messageFilter}
                                 >
                                    No se encontraron coincidencias
                                 </Typography>
                              )}
                           </Grid>
                        </Popover>
                     </div>
                  )}
               </PopupState>
            </Grid>
         </Grid>
      </div>
   )
}

IconsSelector.propTypes = {
   handleIconSelected: PropTypes.func,
   error: PropTypes.bool,
   styleHelperText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
   messageError: PropTypes.string,
   variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
   size: PropTypes.oneOf(['small', 'medium']),
   required: PropTypes.bool,
   value: PropTypes.string
}

IconsSelector.defaultProps = {
   handleIconSelected: () => {},
   styleHelperText: '',
   messageError: 'El campo es obligatorio',
   variant: '',
   size: '',
   required: false,
   value: ''
}
